import moment from 'moment';
import 'moment/locale/id';
import format from "date-fns/format";
import { id } from "date-fns/locale";
moment.locale('id');

export const trackDate = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return format(new Date(timestamp), "cccc, dd MMM yyy", {
    locale: id,
  });
};

export const convertDate = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return format(new Date(timestamp), "dd MMMM Y", {
    locale: id,
  });
};

export const convertDateOnly = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return format(new Date(timestamp), "yyyy-MM-dd", {
    locale: id,
  });
};

export const convertTime = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return format(new Date(timestamp), "hh:mm 'WIB'");
};

export function simplerDateTime(date) {
  return moment(date).locale('id').format('MMMM YYYY')
}

export function dateTime(date) {
  return moment(date).format('lll')
}

export function date(date) {
  return moment(date).format('D MMM Y')
}

export const fullDate = (timestamp) => {
  if (!timestamp) {
    return null;
  }
  return format(new Date(timestamp), "dd MMMM Y 'pukul' HH.mm", {
    locale: id,
  });
};

export function milis(date) {
  return moment(date).format('x')
}

export function time(date) {
  return moment(date).format('hh:mm')
}

export function localDateTime(timestamp) {
  return moment(timestamp).format('llll');
}
